export function initProfileNav() {
    const profileNav = $('.js-profile-menu');

    if (!profileNav.length) {
        return;
    }

    const profileNavBtn = $('.js-profile-menu-btn');

    profileNavBtn.on('click', () => {
        profileNav.stop().slideToggle(300);
        profileNavBtn.toggleClass('profile-menu__menu-toggle--opened');
    });

    $(window).on('resize', () => {
        if (!profileNavBtn.is(':visible')) {
            profileNav.css('display', '');
            profileNavBtn.removeClass('profile-menu__menu-toggle--opened');
        }
    });
}

export function initProfileBuyersSelect() {
    $('.js-buyers-select').on('change', 'select', ({ target }) => {
        if (!target.value) {
            window.location = window.location.pathname;
            return;
        }

        $(target).parents('.js-buyers-select').submit();
    });
}
